import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore } from './agt.analytics.store';

export interface IAgtAdzEmpfehlungModel {
	agtId: number;
	bm: number;
	googleProfile: number;
	socialMediaToolbox: number;
	amisNow: number;
	serviceToSale: number;
	akumaPlaner: number;
	akumaPrime: number;
	meineAllianz: number;
	kvmSupport: number;
	leadNow: number;
}

export class AgtAdzEmpfehlungModel implements IAgtAdzEmpfehlungModel {
	agtId: number;
	bm: number;
	googleProfile: number;
	socialMediaToolbox: number;
	amisNow: number;
	serviceToSale: number;
	akumaPlaner: number;
	akumaPrime: number;
	meineAllianz: number;
	kvmSupport: number;
	leadNow: number;

	constructor(data: any) {
		this.agtId = data.aid || 0;
		this.bm = data.bm ? parseInt(data.bm) : 0;
		this.googleProfile = data.google_profile ? parseInt(data.google_profile) : 0;
		this.socialMediaToolbox = data.social_media_toolbox ? parseInt(data.social_media_toolbox) : 0;
		this.amisNow = data.amis_now ? parseInt(data.amis_now) : 0;
		this.serviceToSale = data.service_to_sale ? parseInt(data.service_to_sale) : 0;
		this.akumaPlaner = data.akuma_planer ? parseInt(data.akuma_planer) : 0;
		this.akumaPrime = data.akuma_prime ? parseInt(data.akuma_prime) : 0;
		this.meineAllianz = data.meineallianz ? parseInt(data.meineallianz) : 0;
		this.kvmSupport = data.kvm_support ? parseInt(data.kvm_support) : 0;
		this.leadNow = data.lead_now ? parseInt(data.lead_now) : 0;
	}
}

export class AgtAdzEmpfehlungStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_adzempfehlungen',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, alias: 'aid' },
				{ column: 'bm', aggregateFunction: AggregateFunction.NONE },
				{ column: 'google_profile', aggregateFunction: AggregateFunction.NONE },
				{ column: 'social_media_toolbox', aggregateFunction: AggregateFunction.NONE },
				{ column: 'amis_now', aggregateFunction: AggregateFunction.NONE },
				{ column: 'service_to_sale', aggregateFunction: AggregateFunction.NONE },
				{ column: 'akuma_planer', aggregateFunction: AggregateFunction.NONE },
				{ column: 'akuma_prime', aggregateFunction: AggregateFunction.NONE },
				{ column: 'meineallianz', aggregateFunction: AggregateFunction.NONE },
				{ column: 'kvm_support', aggregateFunction: AggregateFunction.NONE },
				{ column: 'lead_now', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?adzempfehlung';
	}

	@action
	async findAll(): Promise<AgtAdzEmpfehlungModel[]> {
		const results = await this.query(this.config.defaultColumns);
		return results.map((data) => new AgtAdzEmpfehlungModel(data));
	}
}
